/* eslint-disable local-rules/no-hardcoded-id-in-svg */
import React from 'react'
import { G, Path, Defs, LinearGradient, Stop } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from '../../types'

function FirstMuseumBookingUnlockedDetailedSvg({
  size,
  accessibilityLabel,
  testID,
}: AccessibleIcon) {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 260 260"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M238.706 215.558C238.706 215.558 139.545 254.796 130.655 254.796C121.764 254.796 22.3743 215.956 22.3743 215.956C18.0326 215.962 17.8004 48.9266 22.1453 48.9203C22.1453 48.9203 124.573 5 130.658 5C136.743 5 238.48 48.5227 238.48 48.5227C240.474 48.5227 240.703 215.555 238.709 215.558H238.706Z"
          fill="url(#paint0_linear_8631_22543)"
        />
        <Path
          d="M130.658 254.8C139.548 254.8 238.709 215.561 238.709 215.561C240.703 215.561 240.474 48.5227 238.48 48.5258C238.48 48.5258 136.743 5.00319 130.658 5.00319V254.803V254.8Z"
          fill="url(#paint1_linear_8631_22543)"
        />
        <Path
          d="M234.571 54.7379C234.571 54.7379 136.482 12.4812 130.616 12.4812C124.751 12.4812 25.9941 55.1228 25.9941 55.1228C21.805 55.1291 22.0277 217.298 26.2168 217.292C26.2168 217.292 122.044 255 130.616 255C139.189 255 234.793 216.904 234.793 216.904C236.715 216.904 236.495 54.7315 234.571 54.7347V54.7379ZM226.075 210.081C226.075 210.081 138.483 244.984 130.629 244.984C122.776 244.984 34.9798 210.434 34.9798 210.434C31.1438 210.44 30.9403 61.8597 34.7763 61.8565C34.7763 61.8565 125.257 22.7901 130.629 22.7901C136.002 22.7901 225.871 61.5034 225.871 61.5034C227.634 61.5034 227.837 210.081 226.075 210.081Z"
          fill="#BCB6C3"
        />
        <Path
          d="M238.477 48.5227C238.477 48.5227 136.739 5 130.658 5C124.576 5 22.1453 48.9203 22.1453 48.9203C17.8035 48.9266 18.0326 215.962 22.3743 215.956C22.3743 215.956 121.764 254.796 130.655 254.796C139.545 254.796 238.706 215.558 238.706 215.558C240.7 215.558 240.471 48.5195 238.477 48.5227ZM229.663 208.529C229.663 208.529 138.813 244.481 130.667 244.481C122.521 244.481 31.4618 208.895 31.4618 208.895C27.4827 208.901 27.2727 55.8639 31.2519 55.8575C31.2519 55.8575 125.095 15.6175 130.667 15.6175C136.24 15.6175 229.453 55.4918 229.453 55.4918C231.279 55.4918 231.492 208.526 229.663 208.529Z"
          fill="url(#paint2_linear_8631_22543)"
        />
        <Path
          d="M47.7219 70.311V198.605C47.7219 198.678 47.7665 198.745 47.8301 198.773L106.143 224.29C106.729 224.547 107.244 223.809 106.799 223.348L67.7259 182.726C67.7004 182.701 67.6845 182.666 67.6782 182.631L48.0877 70.2792C48.0495 70.0597 47.7251 70.0852 47.7251 70.311H47.7219Z"
          fill="#E3DEED"
        />
        <Path
          d="M209.713 70.311V198.605C209.713 198.678 209.668 198.745 209.605 198.773L151.291 224.29C150.706 224.547 150.191 223.809 150.636 223.348L189.709 182.726C189.734 182.701 189.75 182.666 189.757 182.631L209.347 70.2792C209.385 70.0597 209.71 70.0852 209.71 70.311H209.713Z"
          fill="#EFEEF0"
        />
        <Path
          d="M218.321 152.412C217.821 152.082 207.364 152.803 205.785 152.638C205.595 152.76 205.605 154.333 205.655 154.638H218.7C218.79 154.116 218.86 152.768 218.321 152.412Z"
          fill="#7F8AA5"
        />
        <Path
          d="M48.8167 152.412C48.3969 152.412 47.957 152.412 47.5372 152.412C45.5778 152.438 43.5285 152.838 41.5291 152.638C41.3192 152.768 41.3592 154.099 41.3992 154.42C44.4182 155.855 51.3659 153.907 54.065 154.864C54.4249 154.994 53.7651 155.446 54.195 155.75C55.0947 155.316 54.6848 153.542 54.5748 152.638C52.6555 152.847 50.6961 152.447 48.8167 152.412Z"
          fill="#7F8AA5"
        />
        <Path
          d="M220.97 211.712L217.551 204.922C216.991 205.514 216.042 204.94 215.632 204.922C215.442 204.922 213.582 205.374 213.333 205.366C213.582 205.366 215.452 204.914 215.632 204.922V204.479V156.081C217.441 155.716 218.381 156.568 218.701 154.638H205.655C205.995 156.516 206.565 155.438 208.214 155.75L202.146 160.662V79.9235C202.146 79.1671 201.446 78.5585 200.577 78.5585H60.8428C59.973 78.5585 59.2733 79.1671 59.2733 79.9235V160.958C57.3139 159.054 55.0047 157.002 52.4055 155.968C52.8754 155.864 54.115 155.785 54.1949 155.742C53.7751 155.438 54.4249 154.977 54.065 154.855C51.3659 153.899 44.4182 155.846 41.3992 154.412C41.6091 156.246 42.8287 155.968 44.7281 156.194C44.808 156.203 44.898 156.194 44.988 156.194V204.922C44.6881 204.931 44.7281 205.279 44.2182 204.922V205.366C44.1283 205.366 44.0483 205.366 43.9583 205.366C43.8684 205.366 42.8687 204.94 42.2989 205.14C41.5091 205.427 39.4398 211.06 38.5901 212.034C39.5098 212.017 40.5594 211.817 41.4092 211.808C44.6881 211.782 48.087 212.034 51.3859 212.034C53.3452 212.034 55.3046 212.043 57.2739 212.034C56.7541 211.208 54.3549 205.461 53.945 205.244C53.7151 205.122 52.0457 205.027 51.3859 204.914C51.3059 204.896 51.2059 204.931 51.126 204.914C51.5558 205.296 51.076 205.401 50.5062 205.409C51.066 205.401 51.5458 205.288 51.116 204.914C50.7961 204.835 50.0463 205.053 49.8364 204.801C50.0463 205.053 50.7961 204.827 51.116 204.905C51.1959 204.922 51.2859 204.888 51.3759 204.905V202.905C51.3759 196.533 51.6258 190.126 51.6358 183.77C51.6358 182.145 51.6358 180.502 51.6358 178.876C51.6358 178.493 51.3759 178.285 51.3759 177.763C51.3759 175.398 51.6258 172.982 51.6358 170.643C51.6458 167.044 51.4658 163.592 51.6358 159.967C53.4052 163.053 56.3342 163.184 59.2733 163.279V179.519C56.9241 178.389 55.3246 175.981 53.945 173.981C53.2253 172.947 52.6954 171.886 51.8957 170.869C51.8657 170.825 51.9357 170.608 51.6358 170.643C51.6358 172.982 51.3859 175.398 51.3759 177.763C51.3759 178.285 51.6358 178.493 51.6358 178.876C52.3855 179.337 52.8354 180.067 53.4252 180.658C55.0547 182.284 56.954 183.753 59.2733 184.266C56.964 183.753 55.0647 182.284 53.4252 180.658C52.8354 180.067 52.3855 179.337 51.6358 178.876C51.6358 180.502 51.6358 182.145 51.6358 183.77C52.1556 183.649 52.1256 183.979 52.1456 183.997C54.3749 184.84 56.8841 185.066 59.2733 184.831V210.391C59.2733 210.652 59.3632 210.886 59.5032 211.095C59.4132 211.165 59.3333 211.217 59.2733 211.251L59.8431 211.747H60.6928C60.7428 211.747 60.7928 211.764 60.8528 211.764H66.081C66.0411 211.869 68.0604 211.877 68.0904 211.843C68.0704 211.886 68.0404 211.93 68.0204 211.964C68.0204 211.964 80.9761 212.034 80.8162 211.756H179.604C179.594 211.851 189.001 211.756 189.001 211.756H200.577C200.627 211.756 200.687 211.747 200.737 211.738H202.096C202.516 211.582 202.426 211.225 202.076 210.791C202.126 210.66 202.156 210.53 202.156 210.382V184.883C203.876 184.935 205.625 184.735 207.205 184.214C210.414 183.136 208.664 181.328 208.744 178.876C208.834 176.198 209.024 173.555 209.004 170.869C206.915 172.782 204.935 177.181 202.166 179.085V163.331C204.435 163.149 206.575 162.732 208.494 160.854C208.494 160.045 209.014 158.706 208.754 157.741C208.834 157.637 208.864 156.881 209.264 156.855V187.561C209.264 187.665 209.264 187.761 209.264 187.865V187.561C209.264 191.569 209.164 195.603 209.264 199.619V199.541C209.304 201.262 209.384 202.975 209.524 204.688C209.384 203.001 209.314 201.306 209.264 199.619V204.688V204.914C209.264 204.914 209.114 205.088 208.494 205.14C207.854 205.192 206.675 204.992 206.195 205.253C205.835 205.444 203.426 211.225 202.866 212.043C203.796 212.069 204.745 212.043 205.685 212.043C208.774 212.043 211.913 212.382 215.022 212.043L214.942 211.712H221H220.97ZM51.7857 177.72C52.0357 177.546 51.8857 177.085 51.8957 176.781C51.9557 174.816 51.8457 172.842 51.8957 170.886C51.8457 172.842 51.9557 174.825 51.8957 176.781C51.8957 177.085 52.0357 177.554 51.7857 177.728V177.72ZM48.9467 156.211C48.5568 156.211 48.1669 156.194 47.7971 156.185C48.1769 156.185 48.5568 156.203 48.9467 156.211ZM47.2672 205.34C48.067 205.366 48.8667 205.427 49.5865 205.583C48.8567 205.418 48.067 205.357 47.2672 205.331V205.34Z"
          fill="#7F8AA5"
        />
        <Path
          d="M40.4495 146.935C40.4895 147.144 40.5395 147.352 40.5995 147.552C40.6195 147.613 40.6295 147.674 40.6495 147.735C40.7394 147.987 40.8394 148.23 40.9594 148.474C40.9793 148.517 41.0093 148.561 41.0293 148.604C41.1293 148.795 41.2493 148.987 41.3692 149.169C41.3892 149.204 41.4092 149.239 41.4292 149.274C41.4292 149.274 41.4392 149.274 41.4492 149.282C42.7688 151.143 45.128 152.395 47.8271 152.395C51.9657 152.395 55.3146 149.482 55.3146 145.883C55.3146 143.84 54.235 142.023 52.5455 140.832C52.3856 140.719 52.2156 140.606 52.0357 140.502C51.9757 140.467 51.9158 140.441 51.8558 140.406C51.7258 140.336 51.5959 140.258 51.4559 140.197C51.3759 140.163 51.296 140.128 51.206 140.084C51.086 140.032 50.9661 139.98 50.8361 139.928C50.7461 139.893 50.6562 139.867 50.5662 139.832C50.4462 139.789 50.3163 139.745 50.1863 139.71C50.0963 139.684 50.0064 139.658 49.9064 139.632C49.7765 139.597 49.6365 139.571 49.4965 139.537C49.4066 139.519 49.3166 139.502 49.2266 139.484C49.0767 139.458 48.9167 139.441 48.7568 139.424C48.6768 139.415 48.5968 139.406 48.5169 139.397C48.2769 139.38 48.037 139.363 47.7971 139.363C43.6585 139.363 40.3096 142.275 40.3096 145.874C40.3096 146.153 40.3396 146.422 40.3795 146.692C40.3895 146.77 40.4095 146.839 40.4195 146.918L40.4495 146.935Z"
          fill="#7F8AA5"
        />
        <Path
          d="M204.885 146.935C204.925 147.144 204.975 147.352 205.035 147.561C205.055 147.622 205.065 147.683 205.085 147.735C205.175 147.987 205.275 148.239 205.395 148.482C205.415 148.526 205.445 148.561 205.465 148.604C205.565 148.804 205.685 148.995 205.815 149.178C205.835 149.213 205.855 149.248 205.875 149.282C205.875 149.282 205.885 149.282 205.895 149.291C207.214 151.151 209.574 152.403 212.273 152.403C216.401 152.403 219.76 149.491 219.76 145.892C219.76 143.857 218.681 142.032 216.991 140.841C216.821 140.728 216.651 140.615 216.481 140.51C216.431 140.475 216.371 140.449 216.321 140.423C216.181 140.345 216.051 140.276 215.901 140.206C215.822 140.171 215.742 140.136 215.662 140.102C215.542 140.05 215.412 139.997 215.282 139.945C215.192 139.91 215.112 139.884 215.022 139.85C214.892 139.806 214.772 139.763 214.642 139.728C214.552 139.702 214.462 139.676 214.372 139.65C214.232 139.615 214.102 139.589 213.962 139.554C213.872 139.537 213.782 139.519 213.692 139.502C213.542 139.476 213.382 139.458 213.222 139.441C213.142 139.441 213.072 139.424 212.992 139.415C212.753 139.397 212.513 139.38 212.273 139.38C208.134 139.38 204.785 142.292 204.785 145.892C204.785 146.17 204.815 146.439 204.855 146.709C204.865 146.787 204.885 146.857 204.895 146.935H204.885Z"
          fill="#7F8AA5"
        />
        <Path
          d="M196.225 66.0605H65.0791C64.2633 66.0605 63.6021 66.7218 63.6021 67.5375V208.351C63.6021 209.166 64.2633 209.828 65.0791 209.828H196.225C197.041 209.828 197.702 209.166 197.702 208.351V67.5375C197.702 66.7218 197.041 66.0605 196.225 66.0605Z"
          fill="#515151"
        />
        <Path
          d="M188.555 74.8046L188.768 200.506C190.158 201.64 191.444 203.524 192.834 204.572C193.228 204.867 193.141 205.062 193.69 204.678L193.903 205.32H68.3087C68.3244 205.183 68.2772 205.002 68.3087 204.892C68.4346 204.444 72.1215 201.525 72.588 200.719L72.8016 140.704C73.6783 141.649 74.6832 142.537 75.5825 143.485C74.3393 144.464 75.0047 145.193 74.9406 146.052C74.4056 153.199 74.681 160.507 74.9406 167.662C74.9552 168.077 74.4697 169.614 74.7271 170.122L75.5825 169.801L74.7271 170.978V200.29C78.6433 200.515 82.5764 200.357 86.4948 200.397C87.3053 200.405 88.037 200.406 88.8486 200.397C91.0495 200.372 93.2853 200.492 95.4817 200.397C96.0493 200.372 96.463 200.733 97.0868 200.61L97.6219 200.182L186.523 200.396L186.201 113.742L186.629 113.207C186.778 112.63 186.402 111.951 186.416 111.816C187.545 100.255 186.104 87.5458 186.523 75.8713H75.0485L74.7271 133.64C74.0403 134.338 73.2332 135.075 72.588 135.779L72.9095 74.8001H188.555V74.8046Z"
          fill="#A6A9B1"
        />
        <Path
          d="M193.476 70.3106L188.555 74.8034H72.9093L72.5878 135.782C72.2539 136.147 70.4217 137.989 70.4487 138.243C71.2884 139.013 72.0302 139.872 72.8025 140.704L72.5889 200.719C72.1235 201.525 68.4366 204.444 68.3096 204.892L67.8813 70.2038L193.476 70.3106Z"
          fill="#C9C9CB"
        />
        <Path
          d="M193.689 204.677C193.14 205.059 193.226 204.866 192.834 204.57C191.444 203.523 190.158 201.64 188.768 200.505L188.555 74.8034L193.476 70.3106L193.689 204.677Z"
          fill="#C9C9CB"
        />
        <Path
          d="M68.3084 205.32H193.903C194.432 205.909 199.051 209.198 197.647 209.813H64.1359L63.6008 209.278C64.3528 208.789 67.3069 205.225 67.7733 205.105C67.8014 205.099 67.9004 205.365 68.3084 205.319V205.32Z"
          fill="#777777"
        />
        <Path
          d="M86.4958 200.399C82.5773 200.36 78.6442 200.517 74.728 200.292V170.98L75.5834 169.803L86.8162 158.464C90.1029 161.258 99.7979 173.6 103.505 174.083C105.01 174.278 104.648 173.685 105.324 173.227C111.045 169.348 120.007 159.018 125.437 153.757C127.295 157.72 133.439 152.357 135.492 150.548L86.4958 200.401V200.399Z"
          fill="white"
        />
        <Path
          d="M186.201 113.744L97.6219 200.184L97.0868 200.613C96.463 200.734 96.0505 200.374 95.4817 200.399L186.415 111.82C186.401 111.955 186.778 112.634 186.628 113.21L186.2 113.745L186.201 113.744Z"
          fill="#C9C9CB"
        />
        <Path
          d="M74.9415 167.663C74.6818 160.508 74.4064 153.2 74.9415 146.053L85.212 156.857L74.9415 167.662V167.663Z"
          fill="white"
        />
        <Path
          d="M88.8484 200.399C88.038 200.408 87.3051 200.407 86.4946 200.399L135.491 150.546C138.293 148.079 141.397 144.531 144.05 141.774C139.595 147.814 134.223 153.295 129.073 158.784C115.864 172.857 101.808 186.112 88.8484 200.399Z"
          fill="#C9C9CB"
        />
        <Path
          d="M87.1379 155.253C85.7339 156.483 84.6964 156.819 86.6028 158.249L88.4215 156.537C89.658 157.778 91.0338 158.936 92.2726 160.175L99.3328 167.235C100.401 168.303 101.474 169.376 102.542 170.444C103.464 171.365 104.246 172.458 105.323 173.225C104.647 173.683 105.009 174.277 103.504 174.08C99.797 173.597 90.102 161.256 86.8152 158.461L75.5825 169.801L74.7271 170.122C74.4697 169.614 74.9564 168.077 74.9407 167.662L85.2112 156.857L74.9407 146.053C75.0048 145.194 74.3393 144.465 75.5825 143.486C79.3616 147.466 83.2767 151.35 87.1367 155.253H87.1379Z"
          fill="#C9C9CB"
        />
        <Path
          d="M167.8 85.2875C166.662 91.1798 165.644 97.1194 164.163 102.94C162.559 109.241 160.085 115.442 158.6 121.661C153.042 127.011 147.466 132.355 141.911 137.708L149.613 102.191C155.532 96.4607 161.321 90.5717 167.265 84.8604L167.8 85.2886V85.2875Z"
          fill="url(#paint3_linear_8631_22543)"
        />
        <Path
          d="M141.911 137.708C141.554 138.053 141.206 138.426 140.841 138.778C141.893 137.927 138.052 136.621 137.845 136.639C134.157 132.576 129.907 129.004 125.864 125.3C125.828 125.267 125.9 125.119 125.864 125.086C133.771 117.45 141.717 109.838 149.613 102.192L141.911 137.709V137.708Z"
          fill="#D592F3"
        />
        <Path
          d="M174.218 106.898C169.078 111.873 163.756 116.697 158.6 121.661C160.084 115.442 162.559 109.241 164.163 102.94C165.644 97.1205 166.66 91.1799 167.8 85.2875L181.922 99.0876C179.534 101.843 176.834 104.366 174.22 106.898H174.218Z"
          fill="url(#paint4_linear_8631_22543)"
        />
        <Path
          d="M144.051 141.774C141.398 144.531 138.295 148.079 135.492 150.546C133.438 152.354 127.293 157.717 125.437 153.755C130.577 148.772 135.687 143.746 140.842 138.778C141.207 138.426 141.554 138.053 141.912 137.708C147.467 132.355 153.043 127.011 158.601 121.661C163.757 116.697 169.08 111.873 174.22 106.898C170.478 112.018 166.198 116.942 162.024 121.768C156.199 128.501 150.219 135.361 144.051 141.773V141.774Z"
          fill="#C9C9CB"
        />
        <Path
          d="M92.2724 160.175C91.0336 158.936 89.6578 157.779 88.4213 156.537C87.9964 156.111 87.5592 155.679 87.1377 155.253C83.2776 151.35 79.3637 147.466 75.5835 143.486C74.6831 142.537 73.6793 141.649 72.8025 140.705C72.0303 139.873 71.2884 139.014 70.4488 138.244C70.4229 137.99 72.254 136.148 72.5878 135.784C73.2342 135.08 74.0401 134.343 74.7269 133.645C83.4103 124.813 92.6242 116.432 101.258 107.542L92.2712 160.176L92.2724 160.175Z"
          fill="url(#paint5_linear_8631_22543)"
        />
        <Path
          d="M102.115 107.112C109.028 114.112 116.408 120.639 123.511 127.439C126.193 130.006 128.782 132.745 131.428 135.355L99.3336 167.236L92.2734 160.176L101.26 107.542C101.387 106.966 101.853 107.203 102.116 107.113L102.115 107.112Z"
          fill="url(#paint6_linear_8631_22543)"
        />
        <Path
          d="M125.864 125.085C125.9 125.117 125.828 125.266 125.864 125.298L123.51 127.437C116.408 120.638 109.026 114.111 102.114 107.111C103.172 106.75 104.37 106.848 105.429 106.469C112.087 112.839 119.076 118.862 125.863 125.084L125.864 125.085Z"
          fill="#C9C9CB"
        />
        <Path
          d="M140.841 138.778C135.686 143.748 130.576 148.772 125.436 153.755C120.008 159.017 111.044 169.346 105.323 173.225C104.246 172.457 103.463 171.365 102.542 170.444L136.99 137.066C137.242 137.01 137.635 136.656 137.845 136.638C138.055 136.62 141.893 137.926 140.841 138.777V138.778Z"
          fill="#8768D4"
        />
        <Path
          d="M88.4216 156.537L86.6028 158.249C84.6964 156.819 85.7339 156.484 87.1379 155.253C87.5594 155.679 87.9967 156.111 88.4216 156.537Z"
          fill="#C9C9CB"
        />
        <Path
          d="M136.99 137.066L102.542 170.444C101.473 169.376 100.4 168.303 99.3325 167.235L131.427 135.354L136.99 137.066Z"
          fill="#5F419F"
        />
        <Path
          d="M137.846 136.638C137.635 136.656 137.242 137.009 136.991 137.066L131.428 135.354C128.783 132.744 126.193 130.005 123.511 127.437L125.865 125.298C129.908 129.003 134.158 132.574 137.846 136.638Z"
          fill="#A574C8"
        />
        <Path
          d="M186.414 111.819L95.4814 200.398C93.2861 200.493 91.0493 200.373 88.8484 200.398C101.808 186.111 115.864 172.856 129.073 158.783C134.223 153.295 139.595 147.813 144.05 141.773C150.217 135.36 156.197 128.501 162.022 121.768C166.197 116.942 170.476 112.018 174.218 106.898C176.833 104.366 179.533 101.843 181.92 99.0876L167.799 85.2875L167.264 84.8593C161.321 90.5706 155.531 96.4595 149.612 102.19C141.715 109.836 133.769 117.448 125.862 125.084C119.075 118.862 112.087 112.839 105.429 106.469C104.369 106.848 103.172 106.75 102.113 107.111C101.85 107.201 101.385 106.964 101.258 107.539C92.6241 116.43 83.4102 124.812 74.7268 133.642L75.0483 75.8735H186.521C186.102 87.548 187.544 100.258 186.414 111.819Z"
          fill="white"
        />
        <Path
          d="M93.3422 99.6238C92.8251 100.193 93.1174 101.084 92.4868 101.871C90.8018 103.969 87.7095 103.042 86.282 101.122C86.8586 97.9388 91.8978 96.9316 93.3422 99.6249V99.6238Z"
          fill="#F5F0FF"
        />
        <Path
          d="M93.3423 99.6238C97.1764 106.767 84.841 109.065 86.2821 101.121C87.7096 103.041 90.8019 103.969 92.4869 101.87C93.1186 101.083 92.8252 100.193 93.3423 99.6226V99.6238Z"
          fill="#C6A9FF"
        />
        <Path
          d="M110.245 87.4277C109.833 91.1517 105.783 91.7239 103.826 88.7114C104.344 86.0035 108.579 84.8503 110.245 87.4277Z"
          fill="#F5F0FF"
        />
        <Path
          d="M103.826 88.7114C105.783 91.7239 109.834 91.1517 110.245 87.4277C110.393 87.6582 110.868 88.6462 110.887 88.8182C111.589 95.3164 102.684 94.679 103.826 88.7114Z"
          fill="#C6A9FF"
        />
        <Path
          d="M148.757 87.856C150.605 89.949 153.376 89.6118 154.107 86.7859C156.967 92.0206 147.687 93.8989 148.757 87.856Z"
          fill="#C6A9FF"
        />
        <Path
          d="M154.106 86.7859C153.377 89.6118 150.605 89.949 148.757 87.856C149.167 85.5404 152.853 84.4928 154.106 86.7859Z"
          fill="#F5F0FF"
        />
        <Path
          d="M118.162 103.903C118.421 105.76 116.582 106.832 114.846 106.47C114.216 106.339 113.744 104.978 113.24 105.829C113.285 103.171 116.497 101.852 118.162 103.903Z"
          fill="#F5F0FF"
        />
        <Path
          d="M113.24 105.829C113.744 104.978 114.216 106.339 114.845 106.47C116.582 106.832 118.422 105.76 118.161 103.903C121.562 108.091 113.145 111.512 113.24 105.829Z"
          fill="#C6A9FF"
        />
        <Path
          d="M129.394 86.3576C142.926 84.4996 142.521 104.48 129.394 102.833C120.225 101.682 120.442 87.5873 129.394 86.3576Z"
          fill="#B586E2"
        />
        <Path
          d="M129.608 87.4277C141.501 85.7574 140.942 103.234 129.608 101.763C121.381 100.695 121.829 88.5203 129.608 87.4277Z"
          fill="#082026"
        />
        <Path
          d="M125.65 98.5536C128.581 95.5468 132.463 94.4239 136.241 92.9907C136.652 92.8344 137.272 92.7108 137.204 92.1353C140.025 99.2483 130.292 104.466 125.65 98.5536Z"
          fill="#4665B6"
        />
        <Path
          d="M137.204 92.1353C137.273 92.7108 136.652 92.8356 136.241 92.9907C132.463 94.4239 128.58 95.5468 125.65 98.5536C125.095 97.8455 124.574 97.0901 124.366 96.1999C127.482 93.1312 131.525 91.417 135.492 89.7815C136.563 90.7201 136.67 90.7898 137.204 92.1353Z"
          fill="#819FEE"
        />
        <Path
          d="M135.492 89.7815C131.525 91.417 127.482 93.1312 124.366 96.1999C124.172 95.3669 124.036 94.4857 124.153 93.6325L133.995 88.7114C134.88 89.0655 134.877 89.2419 135.492 89.7815Z"
          fill="#4665B6"
        />
        <Path
          d="M133.994 88.7114L124.152 93.6325C124.751 89.2397 130.075 87.1433 133.994 88.7114Z"
          fill="#819FEE"
        />
        <Path
          d="M97.6218 200.184L186.201 113.744L186.521 200.399L97.6218 200.184Z"
          fill="url(#paint7_linear_8631_22543)"
        />
        <Path
          d="M126.292 187.988C125.952 190.911 123.137 191.326 121.371 189.272C121.671 186.898 125.077 185.977 126.292 187.988Z"
          fill="#F5F0FF"
        />
        <Path
          d="M121.371 189.273C123.137 191.327 125.95 190.912 126.292 187.989C129.253 192.89 120.625 195.181 121.371 189.273Z"
          fill="#7E9FF8"
        />
        <Path
          d="M174.647 184.566C174.104 187.544 171.85 187.627 169.726 185.849C170.034 183.779 173.337 182.549 174.647 184.566Z"
          fill="#F5F0FF"
        />
        <Path
          d="M169.726 185.849C171.85 187.627 174.104 187.544 174.647 184.565C177.717 189.296 168.92 191.263 169.726 185.849Z"
          fill="#7E9FF8"
        />
        <Path
          d="M139.557 184.137C138.281 186.158 136.824 186.407 135.064 184.779C135.554 182.241 138.777 181.962 139.557 184.137Z"
          fill="#F5F0FF"
        />
        <Path
          d="M139.557 184.137C141.129 188.519 134.223 189.136 135.064 184.779C136.824 186.406 138.281 186.158 139.557 184.137Z"
          fill="#7E9FF8"
        />
        <Path
          d="M169.726 143.486C171.95 147.056 177.531 146.132 177.214 141.56C177.573 142.033 178 142.816 178.069 143.379C179.08 151.496 168.108 150.415 169.726 143.486Z"
          fill="#7E9FF8"
        />
        <Path
          d="M177.214 141.559C177.531 146.131 171.95 147.055 169.726 143.485C170.47 140.294 175.068 138.721 177.214 141.559Z"
          fill="#F5F0FF"
        />
        <Path
          d="M173.256 141.345C177.598 140.876 173.524 144.346 171.009 142.736C170.877 142.413 172.978 141.376 173.256 141.345Z"
          fill="#F5F0FF"
        />
        <Path
          d="M154.855 160.175C170.017 158.077 172.351 178.65 159.348 181.143C143.758 184.133 141.376 162.039 154.855 160.175Z"
          fill="#DEDEDE"
        />
        <Path
          d="M155.711 161.458C168.832 160.163 169.899 178.352 158.707 179.859C144.796 181.733 143.576 162.656 155.711 161.458Z"
          fill="#082026"
        />
        <Path
          d="M165.661 170.23C166.116 179.948 151.923 182.321 148.759 173.868C154.074 171.461 159.799 170.19 165.661 170.23Z"
          fill="#4665B6"
        />
        <Path
          d="M164.376 166.379C165.106 167.628 165.589 168.724 165.66 170.23C159.797 170.19 154.073 171.461 148.758 173.868C148.338 172.747 148.085 171.434 148.116 170.23C153.353 168.299 158.707 166.424 164.376 166.379Z"
          fill="#819FEE"
        />
        <Path
          d="M164.376 166.379C158.707 166.424 153.353 168.299 148.116 170.23C148.148 168.964 148.464 168.327 148.971 167.235L162.451 164.239C163.313 164.882 163.831 165.445 164.376 166.378V166.379Z"
          fill="#4665B6"
        />
        <Path
          d="M162.451 164.239L148.971 167.235C151.353 162.102 158.011 160.929 162.451 164.239Z"
          fill="#819FEE"
        />
        <Path
          d="M213.243 148.172C212.941 150.257 212.061 149.342 210.361 149.733V201.963C209.698 202.358 208.921 202.192 208.2 202.203L208.44 150.214C207.937 149.361 206.568 150.116 206.279 150.094C205.641 150.046 204.453 150.107 204.358 150.094C203.636 149.991 203.936 149.492 203.397 149.373C201.852 149.036 201.318 150.197 200.996 148.173H213.242L213.243 148.172Z"
          fill="#1A264F"
        />
        <Path
          d="M213.244 148.172H200.997C200.944 147.841 200.937 146.138 201.117 146.01C202.596 146.195 212.414 145.416 212.884 145.77C213.395 146.155 213.327 147.604 213.244 148.171V148.172Z"
          fill="#3D3D54"
        />
        <Path
          d="M192.352 157.777C192.65 157.777 193.062 157.831 193.313 157.777V158.017C191.459 158.381 190.096 159.91 187.309 159.698C187.185 159.689 185.242 159.09 184.908 158.977C184.558 158.859 184.21 158.281 183.467 158.016C182.506 156.926 181.509 155.7 181.066 154.295C180.87 153.673 181.371 153.075 181.307 152.733L188.391 158.016C189.436 158.005 191.949 159.144 192.353 157.776L192.352 157.777Z"
          fill="#5F3266"
        />
        <Path
          d="M181.065 151.293C182.137 151.6 184.152 152.112 185.387 151.773L189.829 157.056C190.852 157.686 191.134 157.772 192.351 157.777C191.947 159.145 189.434 158.006 188.388 158.017L181.305 152.734C181.108 151.704 180.32 151.761 179.864 151.054V150.813C180.478 151.189 180.428 151.111 181.064 151.293H181.065Z"
          fill="#9962AE"
        />
        <Path
          d="M203.878 151.533C204.131 152.571 203.637 154.021 203.637 154.895C200.65 158.275 197.066 157.281 193.312 158.016V157.776C194.272 157.569 195.394 156.273 196.433 155.855C199.479 154.631 201.788 154.585 203.878 151.533Z"
          fill="#9962AE"
        />
        <Path
          d="M204.359 150.093V150.573C203.979 150.601 203.956 151.42 203.879 151.534C201.791 154.586 199.481 154.632 196.435 155.856L203.398 149.372C203.937 149.49 203.636 149.989 204.359 150.093Z"
          fill="#D592F3"
        />
        <Path
          d="M210.361 202.441C210.187 202.432 208.436 202.928 208.2 202.921C207.271 202.894 205.21 202.401 204.358 202.441V202.201H206.519C207.077 202.201 207.642 202.209 208.2 202.201C208.922 202.19 209.697 202.356 210.361 201.96V202.44V202.441Z"
          fill="#A18880"
        />
        <Path
          d="M185.868 171.704V202.921C185.517 202.891 185.686 203.409 185.508 203.401C184.746 203.368 183.99 203.443 183.227 203.401L182.986 164.5C183.491 166.358 184.966 169.974 185.868 171.704Z"
          fill="#283A69"
        />
        <Path
          d="M182.026 158.497C182.737 159.988 182.486 162.66 182.987 164.501L183.228 203.402C183.148 203.398 183.067 203.409 182.987 203.402C182.592 203.368 181.243 203.532 181.066 203.282L181.546 157.897C181.739 157.775 181.989 158.42 182.026 158.497Z"
          fill="#7482B0"
        />
        <Path
          d="M208.201 202.922L209.762 210.127C206.84 210.49 203.9 210.125 200.997 210.127L203.638 202.682C204.223 202.628 204.321 202.444 204.359 202.441C205.212 202.401 207.272 202.894 208.201 202.921V202.922Z"
          fill="#585366"
        />
        <Path
          d="M182.986 203.882C183.48 203.948 183.953 203.824 184.427 203.762L185.388 210.005C183.013 210.821 180.546 210.073 178.184 210.125L180.826 203.642C181.551 203.621 182.272 203.787 182.987 203.882H182.986Z"
          fill="#3D3D54"
        />
        <Path
          d="M203.639 202.682L200.997 210.127C200.122 210.127 199.229 210.157 198.355 210.127C198.878 209.244 201.136 203.009 201.477 202.802C201.934 202.525 203.034 202.738 203.639 202.682Z"
          fill="#88818B"
        />
        <Path
          d="M180.826 203.643L178.184 210.127C177.614 210.139 177.057 210.118 176.504 210.127C176.574 208.774 177.676 206.035 178.425 204.844C178.563 204.623 178.582 203.821 179.025 203.643C179.268 203.545 180.395 203.655 180.826 203.643Z"
          fill="#88818B"
        />
        <Path
          d="M208.201 202.202C207.644 202.21 207.078 202.202 206.521 202.202L206.28 150.093C206.568 150.114 207.938 149.36 208.442 150.213L208.201 202.202Z"
          fill="#404D7D"
        />
        <Path
          d="M206.28 150.093L206.52 202.202H204.599C204.159 196.061 204.361 189.865 204.359 183.711C204.359 183.073 204.359 182.429 204.359 181.79C204.359 179.313 204.359 176.824 204.359 174.346V150.092C204.454 150.105 205.643 150.043 206.28 150.092V150.093Z"
          fill="#8894BE"
        />
        <Path
          d="M183.467 158.016C184.21 158.281 184.558 158.859 184.908 158.977C185.969 164.033 188.442 176.128 195.475 175.547C199.333 175.228 201.637 168.306 204.12 165.702C204.139 168.607 203.963 171.458 203.879 174.347C201.759 177.242 199.121 179.825 195.475 180.59C191.199 179.768 187.766 175.343 185.869 171.705C184.968 169.975 183.493 166.359 182.987 164.501C182.487 162.66 182.737 159.988 182.026 158.497C181.849 156.902 182.625 157.718 183.467 158.017V158.016Z"
          fill="#D592F3"
        />
        <Path
          d="M187.309 159.698C188.481 165.523 190.278 172.008 195.473 175.547C188.441 176.129 185.968 164.035 184.907 158.977C185.241 159.09 187.183 159.688 187.308 159.698H187.309Z"
          fill="#90579B"
        />
        <Path
          d="M204.598 202.202H204.358V183.711C204.359 189.865 204.158 196.061 204.598 202.202Z"
          fill="white"
        />
        <Path
          d="M202.437 180.11C200.272 180.944 197.746 181.027 195.473 180.59C199.12 179.824 201.758 177.242 203.878 174.347C203.801 176.993 205.45 178.95 202.437 180.11Z"
          fill="#90579B"
        />
        <Path
          d="M75.6464 151.053C77.0032 151.52 76.5378 151.742 78.768 151.773C78.7488 153.174 75.5531 156.045 74.3257 156.816C72.4226 158.011 71.2458 158.1 69.1629 158.737C68.1546 158.551 67.2553 157.897 66.6416 157.776C63.048 157.065 58.7204 158.51 56.4363 153.934C56.4689 153.141 56.4363 152.326 56.4363 151.533C57.4243 152.487 58.4517 153.992 59.6781 154.654C61.3788 155.572 62.93 155.343 64.3609 155.855C65.2658 156.179 66.5472 157.616 67.3621 157.776C70.8523 158.459 73.5107 154.364 75.6464 152.133C75.6374 152.043 74.4482 151.266 74.2054 151.053V150.812C74.5336 151.04 75.3924 150.965 75.6464 151.053Z"
          fill="#9962AE"
        />
        <Path
          d="M57.1556 149.612C59.9365 150.882 62.3645 153.584 64.3597 155.855C62.9287 155.343 61.3775 155.572 59.6768 154.654C58.4505 153.992 57.4231 152.487 56.4351 151.533V149.852C56.4722 149.847 56.8487 149.692 57.1556 149.612Z"
          fill="#D592F3"
        />
        <Path
          d="M58.1165 176.267C60.1365 178.584 62.5993 180.611 65.8006 180.349C62.9702 181.107 59.7037 181.085 56.916 179.869C56.8913 179.858 56.925 179.498 56.4361 179.629C56.4361 177.873 56.4327 176.104 56.4361 174.346C57.142 174.839 57.5635 175.631 58.1165 176.267Z"
          fill="#90579B"
        />
        <Path
          d="M79.368 210.127C79.0814 209.979 77.7584 204.296 77.8067 203.884C77.8348 203.644 78.0596 203.616 78.0473 203.404C78.4013 203.47 78.2754 204.388 79.0083 203.524L78.0473 162.821C78.3103 161.781 78.1743 160.232 78.7678 159.219C78.7678 173.69 79.2669 188.203 79.0083 202.683C78.9465 203.869 80.3583 203.187 80.8091 203.404C81.7668 203.863 83.6518 210.15 84.1711 210.367"
          fill="#1A264F"
        />
        <Path
          d="M74.2053 203.643C73.7591 204.582 72.2663 209.611 71.8043 210.006C71.1153 210.596 70.0733 210.103 69.8833 210.127C70.2464 209.142 71.8021 204.476 72.2843 204.003C72.9183 203.382 73.4702 203.721 74.2053 203.643Z"
          fill="#88818B"
        />
        <Path
          d="M79.729 152.014C79.0579 153.203 79.8639 154.541 78.7679 156.336C78.5881 156.63 76.023 158.814 75.6464 158.977C74.9933 159.261 74.2031 159.403 73.4848 159.457C71.3053 159.622 70.8411 159.046 69.1628 158.737C71.2457 158.1 72.4226 158.011 74.3256 156.816C75.5531 156.045 78.7488 153.174 78.7679 151.773C79.0725 151.778 79.6705 151.62 79.729 152.014Z"
          fill="#5F3266"
        />
        <Path
          d="M76.6063 203.162C76.0814 203.06 75.0877 203.304 74.6853 203.162V171.704C75.6171 169.837 76.4433 167.687 77.0863 165.7L76.6063 203.162Z"
          fill="#8894BE"
        />
        <Path
          d="M78.0472 203.402C77.5763 203.315 77.0851 203.255 76.6062 203.162L77.0862 165.7C77.3649 164.838 77.8449 163.616 78.0472 162.818L79.0083 203.522C78.2766 204.387 78.4024 203.468 78.0472 203.401V203.402Z"
          fill="#404D7D"
        />
        <Path
          d="M75.6464 158.977C75.0214 163.287 73.5894 168.36 71.0838 171.945C69.3753 174.389 67.7881 176.339 64.8408 175.546C70.1059 172.314 72.4035 165.249 73.486 159.457C74.2031 159.403 74.9944 159.26 75.6475 158.977H75.6464Z"
          fill="#90579B"
        />
        <Path
          d="M75.6466 158.977C75.0216 163.287 73.5896 168.36 71.0841 171.945C69.3755 174.389 67.7883 176.339 64.841 175.546C61.932 174.764 60.1301 171.602 58.598 169.062C57.9247 167.947 57.4234 166.8 56.677 165.7C56.632 167.816 56.7377 169.947 56.677 172.064C56.6646 172.502 56.9175 173.25 56.197 173.144C56.1959 173.71 56.4376 173.934 56.4376 174.344C57.1435 174.838 57.565 175.63 58.118 176.265C60.138 178.583 62.6008 180.61 65.8021 180.348C69.2563 179.423 71.908 176.446 73.4862 173.384C73.5165 173.423 73.7009 173.346 73.7267 173.384C73.9088 172.769 74.4135 172.251 74.6878 171.704C75.6196 169.837 76.4458 167.687 77.0888 165.7C77.3675 164.838 77.8475 163.616 78.0498 162.818C78.3129 161.779 78.1769 160.23 78.7704 159.217V156.335C78.5905 156.629 76.0254 158.813 75.6489 158.976L75.6466 158.977Z"
          fill="#D592F3"
        />
        <Path
          d="M54.5143 203.162L56.1948 210.125C53.1013 210.132 49.9056 209.856 46.8291 209.885L49.2301 202.921C49.3099 202.918 49.3897 202.924 49.4706 202.921C51.0837 202.881 52.9507 202.762 54.5132 203.162H54.5143Z"
          fill="#585366"
        />
        <Path
          d="M52.593 145.77C52.9898 145.763 53.3967 145.762 53.7935 145.77C55.5561 145.805 57.3984 146.24 59.1969 146.01C59.2958 146.99 59.6847 148.899 58.8372 149.372C58.4381 149.043 59.0541 148.55 58.7169 148.411C56.181 147.377 49.6626 149.481 46.83 147.931C46.7951 147.59 46.7558 146.147 46.9503 146.01C48.8297 146.234 50.7552 145.801 52.593 145.77Z"
          fill="#3D3D54"
        />
        <Path
          d="M49.231 202.922L46.83 209.886C46.0398 209.894 45.0518 210.106 44.1885 210.127C44.9888 209.073 46.9267 202.989 47.6708 202.682C48.2081 202.461 49.1523 202.925 49.2321 202.922H49.231Z"
          fill="#88818B"
        />
        <Path
          d="M58.8375 149.372C58.7633 149.414 57.5954 149.499 57.157 149.613C56.8513 149.693 56.4747 149.848 56.4365 149.853C55.9554 149.922 55.3428 149.828 54.9955 149.853C54.2952 149.906 53.5387 149.864 52.8339 149.853C51.9234 149.84 51.1456 149.959 50.1924 149.853C50.1137 149.844 50.0305 149.864 49.9518 149.853C48.168 149.611 47.0304 149.915 46.8303 147.932C49.663 149.484 56.1814 147.378 58.7172 148.412C59.0533 148.55 58.4374 149.044 58.8375 149.373V149.372Z"
          fill="#1A1B33"
        />
        <Path
          d="M50.1921 202.441C51.0992 202.405 52.176 202.38 53.0741 202.441C54.5624 202.544 54.4253 202.908 54.5152 202.921V203.162C52.9516 202.762 51.0857 202.882 49.4727 202.921V202.441C49.9493 202.825 49.9088 202.453 50.1932 202.441H50.1921Z"
          fill="#BCA597"
        />
        <Path
          d="M61.7183 210.127C59.8759 210.138 58.0302 210.123 56.1946 210.127L54.5142 203.163V202.922C55.0593 203.007 56.5937 203.1 55.9552 202.443C56.0283 202.463 56.1182 202.427 56.1958 202.443C56.8185 202.57 58.3798 202.671 58.5967 202.802C58.9789 203.035 61.2293 209.231 61.7183 210.127Z"
          fill="#1A1B33"
        />
        <Path
          d="M56.435 149.852V151.533C56.435 152.328 56.4676 153.141 56.435 153.934C56.272 157.85 56.4474 161.575 56.435 165.46C56.4271 167.985 56.2012 170.589 56.1945 173.144C56.1933 173.71 56.435 173.934 56.435 174.344C56.4316 176.102 56.435 177.871 56.435 179.628C56.4316 186.49 56.1945 193.402 56.1945 200.279V202.44C56.118 202.425 56.027 202.461 55.9539 202.44C55.6504 202.354 54.9468 202.594 54.7534 202.32L54.994 149.85C55.3402 149.824 55.9539 149.919 56.435 149.85V149.852Z"
          fill="#1A264F"
        />
        <Path
          d="M52.8337 149.852L53.0742 202.441C52.1761 202.38 51.0993 202.405 50.1921 202.441V149.852C51.1453 149.958 51.9232 149.839 52.8337 149.852Z"
          fill="#8894BE"
        />
        <Path
          d="M54.994 149.852L54.7534 202.322C54.9479 202.597 55.6504 202.356 55.9539 202.443C56.5924 203.1 55.0581 203.007 54.5129 202.923C54.423 202.909 54.5601 202.545 53.0718 202.443L52.8313 149.853C53.5361 149.864 54.2926 149.906 54.9929 149.853L54.994 149.852Z"
          fill="#404D7D"
        />
        <Path
          d="M56.6758 165.702C56.6308 167.817 56.7365 169.948 56.6758 172.065C56.6634 172.503 56.9163 173.251 56.1958 173.145C56.2014 170.59 56.4285 167.986 56.4363 165.461C56.7129 165.421 56.6443 165.654 56.6769 165.702H56.6758Z"
          fill="#D592F3"
        />
        <Path
          d="M184.427 203.762L185.352 209.771H190.611C189.873 208.184 188.528 203.773 187.669 203.401C187.391 203.281 186.435 203.477 185.989 203.401C185.786 203.366 185.894 202.924 185.868 202.921C185.519 202.891 185.685 203.409 185.509 203.401C184.746 203.368 183.99 203.443 183.228 203.401C183.148 203.397 183.067 203.408 182.987 203.401V203.881C183.481 203.947 183.953 203.823 184.428 203.761L184.427 203.762Z"
          fill="url(#paint8_linear_8631_22543)"
        />
        <Path
          d="M215.37 209.773L212.162 202.443C211.636 203.082 210.751 202.463 210.362 202.443C210.187 202.434 208.436 202.929 208.201 202.922L209.685 209.773H215.37Z"
          fill="url(#paint9_linear_8631_22543)"
        />
        <Path
          d="M79.4515 210.165C78.9973 208.901 77.7654 204.239 77.807 203.882C76.7998 203.546 75.2464 203.532 74.2055 203.642C73.8008 204.494 72.3845 208.981 71.8079 210.051L79.4515 210.164V210.165Z"
          fill="url(#paint10_linear_8631_22543)"
        />
        <Path
          d="M52.8674 145.756C56.7474 145.756 59.8928 142.611 59.8928 138.731C59.8928 134.851 56.7474 131.706 52.8674 131.706C48.9874 131.706 45.842 134.851 45.842 138.731C45.842 142.611 48.9874 145.756 52.8674 145.756Z"
          fill="#4665B6"
        />
        <Path
          d="M52.8674 131.706C48.9872 131.706 45.842 134.851 45.842 138.731C45.842 140.071 46.2175 141.322 46.8672 142.387C48.0755 143.369 49.6155 143.958 51.2937 143.958C55.174 143.958 58.3191 140.813 58.3191 136.932C58.3191 135.593 57.9437 134.341 57.294 133.276C56.0856 132.295 54.5456 131.706 52.8674 131.706Z"
          fill="url(#paint11_linear_8631_22543)"
        />
        <Path
          d="M50.1135 138.225C51.6034 138.225 52.8113 137.017 52.8113 135.527C52.8113 134.037 51.6034 132.83 50.1135 132.83C48.6236 132.83 47.4158 134.037 47.4158 135.527C47.4158 137.017 48.6236 138.225 50.1135 138.225Z"
          fill="#F5F0FF"
        />
        <Path
          d="M77.372 152.388C80.0104 152.388 82.1492 150.249 82.1492 147.611C82.1492 144.973 80.0104 142.834 77.372 142.834C74.7336 142.834 72.5947 144.973 72.5947 147.611C72.5947 150.249 74.7336 152.388 77.372 152.388Z"
          fill="#4665B6"
        />
        <Path
          d="M77.372 142.834C74.7338 142.834 72.5947 144.973 72.5947 147.611C72.5947 148.521 72.8499 149.372 73.2916 150.097C74.1133 150.765 75.1598 151.165 76.3019 151.165C78.94 151.165 81.0791 149.026 81.0791 146.388C81.0791 145.477 80.824 144.627 80.3822 143.902C79.5605 143.234 78.514 142.834 77.372 142.834Z"
          fill="url(#paint12_linear_8631_22543)"
        />
        <Path
          d="M75.4993 147.267C76.5124 147.267 77.3337 146.446 77.3337 145.433C77.3337 144.419 76.5124 143.598 75.4993 143.598C74.4861 143.598 73.6648 144.419 73.6648 145.433C73.6648 146.446 74.4861 147.267 75.4993 147.267Z"
          fill="#F5F0FF"
        />
        <Path
          d="M207.201 145.756C211.081 145.756 214.226 142.611 214.226 138.731C214.226 134.851 211.081 131.706 207.201 131.706C203.321 131.706 200.175 134.851 200.175 138.731C200.175 142.611 203.321 145.756 207.201 145.756Z"
          fill="#4665B6"
        />
        <Path
          d="M207.201 131.706C203.32 131.706 200.175 134.851 200.175 138.731C200.175 140.071 200.551 141.322 201.2 142.387C202.409 143.369 203.949 143.958 205.627 143.958C209.507 143.958 212.652 140.813 212.652 136.932C212.652 135.593 212.277 134.341 211.627 133.276C210.419 132.295 208.879 131.706 207.201 131.706Z"
          fill="url(#paint13_linear_8631_22543)"
        />
        <Path
          d="M204.447 138.225C205.937 138.225 207.145 137.017 207.145 135.527C207.145 134.037 205.937 132.83 204.447 132.83C202.957 132.83 201.749 134.037 201.749 135.527C201.749 137.017 202.957 138.225 204.447 138.225Z"
          fill="#F5F0FF"
        />
        <Path
          d="M182.696 152.388C185.335 152.388 187.473 150.249 187.473 147.611C187.473 144.973 185.335 142.834 182.696 142.834C180.058 142.834 177.919 144.973 177.919 147.611C177.919 150.249 180.058 152.388 182.696 152.388Z"
          fill="#4665B6"
        />
        <Path
          d="M182.696 142.834C180.058 142.834 177.919 144.973 177.919 147.611C177.919 148.521 178.174 149.372 178.616 150.097C179.438 150.765 180.484 151.165 181.626 151.165C184.264 151.165 186.403 149.026 186.403 146.388C186.403 145.477 186.148 144.627 185.706 143.902C184.885 143.234 183.838 142.834 182.696 142.834Z"
          fill="url(#paint14_linear_8631_22543)"
        />
        <Path
          d="M180.823 147.267C181.836 147.267 182.658 146.446 182.658 145.433C182.658 144.419 181.836 143.598 180.823 143.598C179.81 143.598 178.989 144.419 178.989 145.433C178.989 146.446 179.81 147.267 180.823 147.267Z"
          fill="#F5F0FF"
        />
        <Path
          d="M54.3318 65.0425C53.7645 64.653 53.789 65.8061 53.6663 66.0423C50.6762 71.7618 49.4311 75.0341 43 77.9292C49.3575 80.6095 50.7989 84.9491 53.6663 90.4846C53.7675 90.684 53.7737 91.6562 54.3318 91.2636C56.0554 85.0533 59.5147 80.8825 65.219 77.9322C59.5024 75.1721 56.3743 70.9921 54.3318 65.0455V65.0425Z"
          fill="#7F8AA5"
        />
        <Path
          d="M54.9668 88.5218C55.1109 86.7063 55.5771 83.8081 55.1876 82.0785C55.5372 81.9313 55.3256 81.6307 55.6323 81.1891C57.4386 78.5946 58.1931 76.9354 61.4101 75.7455C58.4445 75.31 57.365 72.7462 55.4115 70.9675C55.4053 70.8202 55.4176 70.67 55.4115 70.5228C55.3133 68.3913 55.7856 66.036 54.9668 64.0794C55.0895 63.8433 55.0649 62.6902 55.6323 63.0796C57.6778 69.0262 60.8029 73.2062 66.5194 75.9663C60.8121 78.9166 57.3558 83.0905 55.6323 89.2977C55.0711 89.6933 55.068 88.7181 54.9668 88.5187V88.5218Z"
          fill="#A6C2FF"
        />
        <Path
          d="M55.4082 70.5228C54.0098 72.7646 52.1605 74.4882 49.8543 75.7456C51.8017 76.8619 54.6906 79.8612 55.1874 82.0785C55.5738 83.8082 55.1108 86.7063 54.9666 88.5219C52.1022 82.9863 50.6578 78.6498 44.3003 75.9664C50.7314 73.0683 51.9765 69.796 54.9666 64.0795C55.7855 66.0361 55.3132 68.3914 55.4113 70.5228H55.4082Z"
          fill="#85ABFF"
        />
        <Path
          d="M55.4086 70.9676C55.5374 74.3687 55.9545 77.736 55.6294 81.1892C55.3227 81.6308 55.5343 81.9314 55.1847 82.0786C54.6879 79.8613 51.799 76.862 49.8516 75.7456C52.1578 74.4913 54.0101 72.7647 55.4055 70.5229C55.4117 70.6701 55.3994 70.8204 55.4055 70.9676H55.4086Z"
          fill="#5E89E7"
        />
        <Path
          d="M55.6322 81.1892C55.9542 77.739 55.5371 74.3686 55.4114 70.9675C57.368 72.7432 58.4444 75.307 61.41 75.7456C58.193 76.9355 57.4385 78.5977 55.6322 81.1892Z"
          fill="#D8E4FF"
        />
        <Path
          d="M156.888 44.3096C158.192 47.5113 159.593 49.3637 163 50.4217C159.326 51.5656 157.959 53.7461 156.667 57.1993C156.299 53.5284 153.932 51.86 151 50.2009C154.515 49.5385 155.803 47.4592 156.888 44.3126V44.3096Z"
          fill="#7F8AA5"
        />
        <Path
          d="M157.768 43C159.072 46.2017 160.473 48.0541 163.881 49.1121C160.206 50.2561 158.839 52.4365 157.548 55.8898C157.18 52.2188 154.812 50.5505 151.88 48.8913C155.395 48.2289 156.683 46.1496 157.768 43.0031V43Z"
          fill="#85ABFF"
        />
        <Path
          d="M97.3764 51.8629C99.2305 56.4176 101.224 59.0526 106.071 60.5578C100.845 62.1851 98.8989 65.2869 97.0622 70.1993C96.5387 64.9772 93.1707 62.6039 89 60.2437C93.9996 59.3013 95.832 56.3434 97.3764 51.8673V51.8629Z"
          fill="#7F8AA5"
        />
        <Path
          d="M98.6283 50C100.482 54.5546 102.476 57.1897 107.323 58.6949C102.097 60.3221 100.151 63.424 98.3142 68.3364C97.7907 63.1143 94.4227 60.741 90.252 58.3807C95.2516 57.4384 97.0839 54.4805 98.6283 50.0044V50Z"
          fill="#C58CF0"
        />
        <Path
          d="M207.833 84.1328C207.24 83.7261 207.266 84.9302 207.138 85.1768C204.016 91.1493 202.715 94.5663 196 97.5893C202.639 100.388 204.144 104.92 207.138 110.7C207.244 110.908 207.25 111.923 207.833 111.513C209.633 105.029 213.245 100.673 219.202 97.5925C213.232 94.7104 209.966 90.3455 207.833 84.136V84.1328Z"
          fill="#7F8AA5"
        />
        <Path
          d="M208.493 108.65C208.643 106.755 209.13 103.728 208.723 101.922C209.088 101.768 208.867 101.455 209.188 100.993C211.074 98.2842 211.862 96.5517 215.221 95.3092C212.124 94.8544 210.997 92.1772 208.957 90.3198C208.951 90.1661 208.963 90.0092 208.957 89.8554C208.855 87.6298 209.348 85.1703 208.493 83.1272C208.621 82.8806 208.595 81.6765 209.188 82.0832C211.324 88.2927 214.587 92.6576 220.556 95.5397C214.596 98.6205 210.987 102.979 209.188 109.461C208.602 109.874 208.598 108.855 208.493 108.647V108.65Z"
          fill="#E5C3FF"
        />
        <Path
          d="M208.957 89.8554C207.497 92.1964 205.566 93.9961 203.157 95.3091C205.191 96.4748 208.208 99.6068 208.726 101.922C209.13 103.728 208.646 106.755 208.496 108.65C205.505 102.87 203.997 98.3418 197.358 95.5397C204.073 92.5134 205.374 89.0964 208.496 83.1271C209.351 85.1702 208.858 87.6297 208.96 89.8554H208.957Z"
          fill="#C58CF0"
        />
        <Path
          d="M208.957 90.3198C209.091 93.8712 209.527 97.3875 209.187 100.993C208.867 101.455 209.088 101.768 208.723 101.922C208.204 99.6068 205.188 96.4748 203.154 95.3091C205.562 93.9993 207.497 92.1964 208.954 89.8554C208.96 90.0091 208.947 90.166 208.954 90.3198H208.957Z"
          fill="#D7A2FF"
        />
        <Path
          d="M209.188 100.993C209.524 97.3908 209.089 93.8713 208.957 90.3198C211 92.174 212.124 94.8512 215.221 95.3092C211.862 96.5517 211.074 98.2874 209.188 100.993Z"
          fill="#F3E4FF"
        />
        <Path
          d="M147.888 213.31C149.192 216.511 150.593 218.364 154 219.422C150.326 220.566 148.959 222.746 147.667 226.199C147.299 222.528 144.932 220.86 142 219.201C145.515 218.538 146.803 216.459 147.888 213.313V213.31Z"
          fill="#7F8AA5"
        />
        <Path
          d="M148.768 212C150.072 215.202 151.473 217.054 154.88 218.112C151.206 219.256 149.838 221.437 148.547 224.89C148.179 221.219 145.812 219.55 142.88 217.891C146.394 217.229 147.682 215.15 148.768 212.003V212Z"
          fill="#C58CF0"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_8631_22543"
            x1="129.548"
            y1="5"
            x2="129.548"
            y2="254.796"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEEBF3" />
            <Stop offset="1" stopColor="#B5B2BC" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_8631_22543"
            x1="185.376"
            y1="5.00319"
            x2="185.376"
            y2="254.803"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBF6F6" />
            <Stop offset="1" stopColor="#C4C4C4" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_8631_22543"
            x1="129.547"
            y1="5"
            x2="129.547"
            y2="254.796"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEE1E0" />
            <Stop offset="1" stopColor="#C6BAB9" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_8631_22543"
            x1="169.658"
            y1="105.092"
            x2="139.774"
            y2="117.37"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#8A4E8D" />
            <Stop offset="1" stopColor="#A06ABD" />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear_8631_22543"
            x1="177.396"
            y1="98.4076"
            x2="160.067"
            y2="104.593"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5C2F5F" />
            <Stop offset="1" stopColor="#6A3D83" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear_8631_22543"
            x1="98.3007"
            y1="133.82"
            x2="73.7018"
            y2="134.42"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#A37CF1" />
            <Stop offset="1" stopColor="#93AEF9" />
          </LinearGradient>
          <LinearGradient
            id="paint6_linear_8631_22543"
            x1="96.441"
            y1="133.792"
            x2="123.297"
            y2="142.907"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#97B1F9" />
            <Stop offset="1" stopColor="#7E9EF8" />
          </LinearGradient>
          <LinearGradient
            id="paint7_linear_8631_22543"
            x1="97.9864"
            y1="152.883"
            x2="173.016"
            y2="163.737"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#DE77CF" />
            <Stop offset="0.45" stopColor="#A473D7" />
            <Stop offset="1" stopColor="#B2AFEC" />
          </LinearGradient>
          <LinearGradient
            id="paint8_linear_8631_22543"
            x1="183.057"
            y1="205.852"
            x2="190.398"
            y2="207.277"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#555164" />
            <Stop offset="0.89" stopColor="#161834" />
          </LinearGradient>
          <LinearGradient
            id="paint9_linear_8631_22543"
            x1="208.209"
            y1="205.58"
            x2="215.25"
            y2="206.947"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#555164" />
            <Stop offset="0.89" stopColor="#161834" />
          </LinearGradient>
          <LinearGradient
            id="paint10_linear_8631_22543"
            x1="72.9533"
            y1="206.589"
            x2="79.3031"
            y2="207.822"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#555164" />
            <Stop offset="0.89" stopColor="#161834" />
          </LinearGradient>
          <LinearGradient
            id="paint11_linear_8631_22543"
            x1="52.0806"
            y1="131.706"
            x2="52.0806"
            y2="143.958"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5477D6" />
            <Stop offset="0.73" stopColor="#96B1F9" />
          </LinearGradient>
          <LinearGradient
            id="paint12_linear_8631_22543"
            x1="76.8369"
            y1="142.834"
            x2="76.8369"
            y2="151.165"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5477D6" />
            <Stop offset="0.73" stopColor="#96B1F9" />
          </LinearGradient>
          <LinearGradient
            id="paint13_linear_8631_22543"
            x1="206.414"
            y1="131.706"
            x2="206.414"
            y2="143.958"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5477D6" />
            <Stop offset="0.73" stopColor="#96B1F9" />
          </LinearGradient>
          <LinearGradient
            id="paint14_linear_8631_22543"
            x1="182.161"
            y1="142.834"
            x2="182.161"
            y2="151.165"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#5477D6" />
            <Stop offset="0.73" stopColor="#96B1F9" />
          </LinearGradient>
        </Defs>
      </G>
    </AccessibleSvg>
  )
}

export const FirstMuseumBookingUnlockedDetailed = styled(
  FirstMuseumBookingUnlockedDetailedSvg
).attrs(({ size, theme }) => ({
  size: size ?? theme.illustrations.sizes.fullPage,
}))``
